var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconsChevronLeftDouble = function SvgIconsChevronLeftDouble(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11.817 7.21c.224.255.242.656.056.936l-.056.073L8.509 12l3.308 3.78c.244.28.244.732 0 1.01-.224.256-.575.278-.82.065l-.064-.064-3.75-4.286c-.224-.256-.242-.657-.056-.937l.056-.073 3.75-4.286c.244-.279.64-.279.884 0zm5 0c.224.255.242.656.056.936l-.056.073L13.509 12l3.308 3.78c.244.28.244.732 0 1.01-.224.256-.575.278-.82.065l-.064-.064-3.75-4.286c-.224-.256-.242-.657-.056-.937l.056-.073 3.75-4.286c.244-.279.64-.279.884 0z"
  })));
};
export default SvgIconsChevronLeftDouble;